// import { faCalendar } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import 'bootstrap-daterangepicker/daterangepicker.css';
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import { InputField, Button } from "components";
import { IconChevronLeft, IconChevronRight } from "Icons";
// import css from "./search-field.module.scss";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import {  withLabelsContext } from 'context';

const StyledSelect = styled.select`
  margin: 0 4px;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 8px;
`;

class FormDateRangePicker extends PureComponent {
  constructor(props) {
    super();
    this.state = {
      date: new Date(),
    };
  }
  static propTypes = {
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };

  componentDidMount = () => {
    if(this.props.showDefault) {
      const defaultDate =
        moment(new Date(new Date().getTime() + 5 * 60000)).format(
          this.props.timePicker ? "DD-MMM-YYYY hh:mm A" : "DD-MMM-YYYY"
        )
      this.props.onChange(defaultDate)
    }
  }

  handleChange = (date, e) => {
    e && e.stopPropagation();
    const { timePicker, onChange } = this.props;
    this.setState({ date });
    onChange(
      date
        ? moment(date).format(
            timePicker ? "DD-MMM-YYYY hh:mm A" : "DD-MMM-YYYY"
          )
        : ""
    );
    // const { timePicker } = this.props;
    // var today = new Date(picker.startDate);
    // var tt = today.getHours()<12?'AM':'PM';
    // const value = timePicker ?  picker.startDate.format('DD-MMM-YYYY hh:mm ')+tt :
    //                             picker.startDate.format('DD-MM-YYYY');//e.target.value;
    // this.props.onChange(value);
  };
  //   defaultDate = () =>{ moment(new Date(new Date().getTime() + 5 * 60000)).format(
  //   this.props.timePicker ? "DD-MMM-YYYY hh:mm A" : "DD-MMM-YYYY"
  // )}
 
  render() {
    const { value, timePicker, onChange, ...restProps } = this.props;
    const years = Array(2100 - 1990 + 1)
      .fill()
      .map((_, idx) => 1990 + idx);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    // const timePicker = this.props.timePicker ? true : false;
    //let selectDate = value;//(value!=null) ? value : moment().format('DD-MM-YYYY');
    return (
      // <React.Fragment>
      <DatePicker
        autoComplete="off"
        // filterTime={this.props.filterTime ?? ""}
        // minTime={new Date().getDate() ===
        //   new Date(value
        //     ? new Date(
        //         moment(value).format(
        //           timePicker ? "DD-MMM-YYYY hh:mm A" : "DD-MMM-YYYY"
        //         )
        //       )
        //     : "" ?? new Date().getTime()).getDate()
        //     ? new Date()
        //     : new Date().setHours(0, 0, 0)}
        shouldCloseOnSelect={false}
        isClearable={this.props.isClearable || true}
        calendarClassName="date-picker"
        placeholderText={this.props.showPlaceholder ? this.props.placeholder : this.props.ctx_labels.singular.chooseDate}
        selected={
          value
            ? new Date(
                moment(value).format(
                  timePicker ? "DD-MMM-YYYY hh:mm A" : "DD-MMM-YYYY"
                )
              )
            : ""
        }
        // onSelect={this.handleDateChange}
        onChange={(date, e) => this.handleChange(date, e)}
        timeInputLabel="Time:"
        showTimeInput={timePicker}
        dateFormat={timePicker ? "dd-MMM-y p" : "dd-MMM-y"}
        customInput={<InputField autoComplete="off" />}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <>
            <Button
              variant="link"
              iconOnly
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <IconChevronLeft style={{height:"10px", width:"10px"}} />
            </Button>
            <StyledSelect
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </StyledSelect>

            <StyledSelect
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </StyledSelect>

            <Button
              variant="link"
              iconOnly
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <IconChevronRight  style={{height:"10px", width:"10px"}} />
            </Button>
          </>
        )}
        {...restProps}
      />
      // </React.Fragment>
    );
  }
}

export default  withLabelsContext(FormDateRangePicker);
